import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {IAssetRecord } from "../../../config/types";
import { AppThunk } from "../..";

const initialState:Partial<IAssetRecord>   = {}
export const assetDetail = createSlice({
  name: "assetDetail",
  initialState,
  reducers: {
    update: (_state, action: PayloadAction<IAssetRecord>) => {
      return action.payload;
    },
  },
});
export const { update } = assetDetail.actions;
export const updateAssetDetail=(data:IAssetRecord):AppThunk=>  (dispatch)=>{
  dispatch(update(data));
}
export default assetDetail.reducer;
